import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DashboardService } from 'src/app/rest_services/dashboard.service';
import { TeamService } from 'src/app/rest_services/team.service';
import { UserService } from 'src/app/rest_services/user.service';
import { VisitsService } from 'src/app/rest_services/visits.service';
import { history} from './history';

interface History {
  Client: String;
  Action: String;
  Dateaction: Date;
  Status: String;
}

@Component({
  selector: 'app-equipe',
  templateUrl: './equipe.component.html',
  styleUrls: ['./equipe.component.css']
})
export class EquipeComponent implements OnInit {
  action: any[] = [];
  team: any[] = [];
  his: any="";
  DataTable:any;
  teamPlanLoading:boolean=true;teamHistoLoading:boolean = true;
  History: any[] = history;

  fullname:string="";
  phone:string="";
  added_at:Date= new Date();
  email:string="";
  city:string="";
  sales:string="";
  state:string="";
  status:string="";
  commercial_fullname:string="";
  commercial_sells:string="";
  commercial_ratings:string="";
  commercial_phone:string="";
  commercial_email:string="";
  commercial_profile:string="";
  company_to_visit:string="";
  last_visit:string="";
  commercial_status:string="";
  commercial_avatar:any;
  id:any;
  permissionForm:FormGroup;

  constructor(private fb:FormBuilder,private teamServiceservice:TeamService, private visitServiceservice:VisitsService, private userService: UserService,
    private dashboardServiceservice:DashboardService){
    this.Team();
    this.Commercial(this.id);
    this.permissionForm = this.fb.group({
      'permission': ['']
    });
  }
  loading_team:boolean=true;
  loading_actions:boolean=true;
  loading_indicator:boolean=true;
  ngOnInit(): void {
    setTimeout(()=>{
      this.loadScript("../assets/plugins/table/datatable/datatables.js");
    }, 200);
    $('#account').change(function() {
      
      // if(this.checked) {
      //     var returnVal = confirm("Are you sure?");
      //     $(this).prop("checked", returnVal);
      // }
      // $('#textbox1').val(this.checked);        
  });
  }
  public loadScript(scripts:string) {
    let node = document.createElement("script");
    node.src = scripts;
    node.type = "text/javascript";
    node.async = true;
    var scriptsTags = document.getElementsByTagName('script');
    for (var i = scriptsTags.length; i--;) {
        if (scriptsTags[i].src != scripts) {
          document.getElementsByTagName("body")[0].appendChild(node);
        }else {
          break;
        }
    }
  }
  getTeamPlan(){
    this.teamPlanLoading=true;
    setTimeout(()=>{
      this.teamPlanLoading=false;
    }, 1000);
  }
  fullname_actions:any;
  getActionsMember(member:any,fullname:any){
    this.teamHistoLoading=true;
    this.fullname_actions=fullname;
    this.visitServiceservice.getActions(member);
    this.visitServiceservice.actionsSubject.subscribe(
      ( data: any ) => {
        if(data.code =="b8f8289ade38c75780d8156c9d8fd624"){
          this.action = data.actions;
          setTimeout(()=>{
            (<any>$("#alter_paginations")).DataTable( {
              "pagingType": "full_numbers",
              "language": {
                "sProcessing": "Traitement en cours ...",
                "sLengthMenu": "Afficher _MENU_ lignes",
                "sZeroRecords": "Aucun résultat trouvé",
                "sEmptyTable": "Aucune donnée disponible",
                "sInfo": "",
                "sInfoEmpty": "",
                searchPlaceholder: "Saisir un mot clé",
                "sInfoFiltered": "",
                "sInfoPostFix": "",
                "sSearch": "Chercher:",
                "sUrl": "",
                "sInfoThousands": ",",
                "sLoadingRecords": "Chargement...",
                "oPaginate": {
                  "sFirst": "<i class='flaticon-left-arrow'></i>", "sLast": "<i class='flaticon-right-arrow'></i>", "sNext": "<i class='flaticon-arrow-right'></i>", "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
                },
                "oAria": {
                  "sSortAscending": ": Trier par ordre croissant", "sSortDescending": ": Trier par ordre décroissant"
                }
              },
              drawCallback: function () {
                (<any>$('.sparkline')).sparkline([5,6,7,9,9,5,3,2,2,4,6,7], {
                      type: 'line',
                      width: '60',
                      height: '20',
                      lineColor: '#1a73e9',
                      fillColor: '#c2d5ff',
                      spotColor: 'transparent',
                      minSpotColor: 'transparent',
                      maxSpotColor: 'transparent',
                      highlightSpotColor: 'transparent',
                      highlightLineColor: 'transparent',
                  });
              }
          });
        }, 200);
        }this.teamHistoLoading=false;
      },
      )  
  }
  Team(){
    this.teamServiceservice.getTeam();
    this.teamServiceservice.teamSubject.subscribe(
      ( data: any ) => {
        if(data.code =="d9cc2e7dc2cf71242be86ab1ad241752"){
          this.team = data.team;
        }this.loading_team = false;
        setTimeout(()=>{
            (<any>$("#alter_pagination_")).DataTable( {
              "pagingType": "full_numbers",
              "language": {
                "sProcessing": "Traitement en cours ...",
                "sLengthMenu": "Afficher _MENU_ lignes",
                "sZeroRecords": "Aucun résultat trouvé",
                "sEmptyTable": "Aucune donnée disponible",
                "sInfo": "",
                "sInfoEmpty": "Aucune ligne affichée",
                "sInfoFiltered": "(Filtrer un maximum de_MAX_)",
                "sInfoPostFix": "",
                "sSearch": "Chercher:",
                searchPlaceholder: "Saisir un mot clé",
                "sUrl": "",
                "sInfoThousands": ",",
                "sLoadingRecords": "Chargement...",
                "oPaginate": {
                  "sFirst": "<i class='flaticon-left-arrow'></i>", "sLast": "<i class='flaticon-right-arrow'></i>", "sNext": "<i class='flaticon-arrow-right'></i>", "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
                },
                "oAria": {
                  "sSortAscending": ": Trier par ordre croissant", "sSortDescending": ": Trier par ordre décroissant"
                }
              },
              drawCallback: function () {
                (<any>$('.sparkline')).sparkline([5,6,7,9,9,5,3,2,2,4,6,7], {
                      type: 'line',
                      width: '60',
                      height: '20',
                      lineColor: '#1a73e9',
                      fillColor: '#c2d5ff',
                      spotColor: 'transparent',
                      minSpotColor: 'transparent',
                      maxSpotColor: 'transparent',
                      highlightSpotColor: 'transparent',
                      highlightLineColor: 'transparent',
                  });
              }
          });
        }, 200);
      },
    )  
  }
  program:any;
  Programe(uuid:any){
    this.teamPlanLoading=true;
    this.teamServiceservice.getPrograme(uuid);
    this.teamServiceservice.programSubject.subscribe(
      ( data: any ) => {if(data.code =="a3012ec200215ec0fb7a2b3744911348"){
          this.program = data.planning;
        }this.teamPlanLoading=false;
      },
    )  
  }
  commercialid:any;
  fullname_commercial:any;
  getTeamid(member:any){
    this.commercialid = member.uuid;
    this.fullname_commercial = member.fullname; 
    this.Programe(this.commercialid);
  } 
  uuid:any;
  getteamid(member:any){
    this.uuid = member.uuid;
    this.Commercial(this.uuid)
  }
  commercial:any;
  done:any;inprogress:any;
  Commercial(id:any){
    this.loading_indicator=true;
    this.teamServiceservice.getCommercial(id);
    this.teamServiceservice.commercialSubject.subscribe(
      ( data: any ) => {
        if(data.code =="40f8ba1c266eaea7907268ff5965de3d"){
          this.commercial=data.commercial.commercial;
          this.commercial_fullname = data.commercial.commercial_fullname;
          this.commercial_avatar = data.commercial.commercial_avatar;
          this.commercial_phone = data.commercial.commercial_phone;
          this.commercial_email = data.commercial.commercial_email;
          this.commercial_profile = data.commercial.commercial_profile;
          this.commercial_status = data.commercial.commercial_status;
          let profile = this.getProfile(this.commercial_profile)=="Commercial";

          if(profile){
            this.commercial_sells = data.commercial.planned;
            this.commercial_ratings = data.commercial.reported;
            this.done = data.commercial.done;
            // this.inprogress = data.commercial.last_visit.company_to_visit;
            if(data.commercial.last_visit!=null && data.commercial.last_visit != undefined){
              this.last_visit = data.commercial.last_visit.company_to_visit;
            }
            
          }
         
          var status = $( "#account") as any;
          setTimeout(()=>{
            if(this.commercial_status == '9dbecf2631b52926e5dd1a89440ef908'){
              $( "#account").prop("checked", true);
            }else {
              $( "#account").prop("checked", false);
            }
          }, 500);
        } this.loading_indicator=false;
      })
  }
  access:any;
  event:any;
  addOrUpdateLoading:boolean=false;
  Permission(){
    this.addOrUpdateLoading=true;
      if ($('#account').is(":checked"))
        {
         this.commercial_status='cff182167d5017c13d5178ca1836f2a7';
        }else{
          this.commercial_status='9dbecf2631b52926e5dd1a89440ef908';
        }
      var permissionbosy = {
        access:this.commercial_status
      }
      this.teamServiceservice.causeBody = permissionbosy;
      this.teamServiceservice.getPermission(this.commercial,this.access);
      this.teamServiceservice.permissionSubject.subscribe(
        ( data: any ) => { 
          if(data.code =="9ab01aa69febfba12fce4ffffb9a822f"){
            if (this.commercial_status =="cff182167d5017c13d5178ca1836f2a7") {
              this.commercial_status="9dbecf2631b52926e5dd1a89440ef908";
              $("#status-"+this.commercial).html("Non actif");
            }else{
              this.commercial_status="cff182167d5017c13d5178ca1836f2a7"
              $("#status-"+this.commercial).html("Actif");
            };$(".modal").animate({ scrollTop: 0 }, 500);
            $("#successSave").show();
            $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // $(this).removeClass();
            });
            setTimeout(()=>{
              $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                // $(this).removeClass();
              });
              $("#successSave").hide();
            }, 5000);
            }else{
            $("#errors").show();
                  $('.alert-danger').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                    // $(this).removeClass();
                  });
                  setTimeout(()=>{
                    $('.alert-danger').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                      // $(this).removeClass();
                    });
                    $("#errors").hide();
                  }, 5000);
          }this.addOrUpdateLoading=false;
        },)
  }

  getProfile(uuid: string) {
    return this.userService.getProfileName(uuid);
  }



}
